/* eslint-disable no-undef */
import AgoraRTM from "agora-rtm-sdk";
import { mapGetters, mapActions } from "vuex";
import { agoraOptions, LIMIT_CHAT_CONFIGS, RTM_CONFIGS } from "@/configs/Settings";
import { ADMIN_ACC, RTM_MESSAGE_TYPE } from "@/configs/RTM_SDK";
import MessageChannelMixins from "./MessageChannelMixins";
import RtmWorker from "@/workers/rtm.worker";
import { TYPE_WORKERS } from "@/configs/Workers";
import { checkMessageHasUrls } from "@/ultis/Helper";

export default {
   name: "AgoraRtmMixin",
   mixins: [MessageChannelMixins],
   data() {
      return {
         // RTM Rate Limiter
         waitDuration: 0,
         incomingMessages: 0,
         randomDistribution: 0,
         intervalLimit: LIMIT_CHAT_CONFIGS.INTERVAL,

         ADMIN_ACC_DEFAULT: ADMIN_ACC,
         myRtmWorker: null,
      };
   },
   computed: {
      ...mapGetters([
         "client",
         "channels",
         "isLoggedInRtm",
         "publicKey",
         "streamStatistic",
         "listChannelMessages",
         "listLikedAnimations",
         "listUserJoined",
         "listYourMessages",
         "currentChannel",
         "limitChatConfigs",
         "adminChannelMessages"
      ])
   },
   watch: {
      limitChatConfigs: {
         handler(val, oldVal) {
            if (val !== oldVal && this.myRtmWorker) {
               this.myRtmWorker.postMessage({
                  type: TYPE_WORKERS.UPDATE_DATA_CONFIGS,
                  data: {
                     limitChatConfigs: val,
                     intervalLimit: this.intervalLimit
                  }
               });
            }
         },
         deep: true
      },
      intervalLimit(val) {
         this.myRtmWorker.postMessage({
            type: TYPE_WORKERS.UPDATE_DATA_CONFIGS,
            data: {
               limitChatConfigs: this.limitChatConfigs,
               intervalLimit: val
            }
         });
      }
   },
   created() {},
   mounted() {
      this.initialRtmWorker();
   },
   methods: {
      ...mapActions([
         "addNewChannelMessages",
         "updateListChannelMessages",
         "updateAndLimitListChannelMessages",
         "updateListUserJoined",
         "updateStreamStatistic",
         "addNewLikedAnimation",
         "addNewYourMessages",
         "updateStreamEnded",
         "addNewAdminMessages",
         "removeMessageFromList"
      ]),
      initialRtmWorker() {
         this.myRtmWorker = new RtmWorker(this.limitChatConfigs);

         this.myRtmWorker.postMessage({
            type: TYPE_WORKERS.INITIAL_WORKER,
            data: null
         });

         this.myRtmWorker.onmessage = (event) => {
            let typeMessage = event.data.type | null;
            switch (typeMessage) {
               case TYPE_WORKERS.UPDATE_DATA_CONFIGS: {
                  this.waitDuration = event.data.data.waitDuration;
                  this.incomingMessages = event.data.data.incomingMessages;
                  this.randomDistribution = event.data.data.randomDistribution;
                  break;
               }

               case TYPE_WORKERS.UPDATE_CHANNEL_MESSAGES: {
                  requestAnimationFrame(() => {
                     this.updateListChannelMessages(event.data.data);
                  });
                  break;
               }
               
               case TYPE_WORKERS.RECEIVED_NEW_LIKE: {
                  this.addNewLikedAnimation(event.data.data);
                  break;
               }

               default: {
                  console.log(event.data);
                  break;
               }
            }
         };
      },
      /**
       * Init agora rtm
       * @param appId
       * @param uid
       * @param token
       * @returns {Promise<void>}
       */
      initAgoraRtm: async function(appId, uid, token) {
         let _this = this;
         await this.createAgoraRtmInstance(appId).then(() => {
            _this.subscribeAgoraRtmClientEvents();
            setTimeout(function() {
               _this.loginAgoraRtm(uid, token ? token : null);
            }, 300);
         });
      },

      /**
       *
       * @param appId
       * @returns {Promise<void>}
       */
      createAgoraRtmInstance: async function(appId) {
         let rmtInstance = AgoraRTM.createInstance(appId ? appId : agoraOptions.appID);
         this.$store.commit("UPDATE_CLIENT", rmtInstance);
      },

      /**
       *
       * @param uid
       * @param token
       * @returns {Promise<void>}
       */
      loginAgoraRtm: async function(uid, token) {
         let _this = this;
         this.client
            .login({ token: token ? token : null, uid: uid })
            .then(() => {
               this.$store.commit("UPDATE_IS_LOGGED_IN_RTM", true);
               _this.afterLoggedInAgoraRtm();
            })
            .catch((err) => {
               console.log("AgoraRTM client login failure", err);
            });
      },

      /**
       *
       * @returns {Promise<void>}
       */
      logoutAgoraRtm: async function() {
         let _this = this;
         console.log("LOG OUT RTM");
         if (this.isLoggedInRtm && this.client) {
            await this.client.logout().then(() => {
               _this.$store.commit("UPDATE_IS_LOGGED_IN_RTM", false);
               console.log("UPDATE_IS_LOGGED_IN_RTM FALSE");
            });
         }
      },

      /**
       *
       * @param channel
       * @param channelEvents
       * @param prefixMethod
       */
      joinChannelRtm: function(channel, channelEvents = RTM_CONFIGS.CHANNEL_EVENTS, prefixMethod = RTM_CONFIGS.PREFIX_METHOD) {
         if (channel) {
            let _this = this;
            // create channel rtm:
            console.log("RTM ======================== START JOIN");
            this.joinAgoraRtmChannel(channel, channelEvents, prefixMethod)
               .then(() => {
                  _this.sendJoinMessageChannel(channel);
                  _this.afterJoinedChannelSuccess(channel);
               })
               .catch((err) => {
                  console.error(err);
               });
         }
      },

      sendJoinMessageChannel(channel) {
         this.$store.commit("UPDATE_STATUS_JOIN_OF_CHANNEL", {
            name: channel,
            joined: true
         });
      },

      afterJoinedChannelSuccess: function() {},

      /**
       *
       * @param channel
       */
      leaveChannelRtm: async function(channel) {
         this.leaveAgoraRtmChannel(channel);
      },

      // hook after login to agora rtm:
      afterLoggedInAgoraRtm: function() {},

      // subscribe client events
      subscribeAgoraRtmClientEvents: function() {
         const clientEvents = ["ConnectionStateChanged", "MessageFromPeer"];
         clientEvents.forEach((eventName) => {
            this.client.on(eventName, (...args) => {
               // log event message
               let eventNameEmit = eventName
                  .replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
                  .replace(/[\s_]+/g, "-") // replace all spaces and low dash
                  .toLowerCase(); // convert to lower case

               this.$root.$emit(eventNameEmit, ...args);
            });
         });
      },

      /**
       *
       * @param channelName
       * @param channelEvents
       * @param prefixMethod
       */
      subscribeAgoraRtmChannelEvents: function(channelName, channelEvents = RTM_CONFIGS.CHANNEL_EVENTS, prefixMethod = RTM_CONFIGS.PREFIX_METHOD) {
         channelEvents.forEach((eventName) => {
            this.channels[channelName].channel.on(eventName, (...args) => {
               if (typeof this[`${prefixMethod}${eventName}`] === "function") {
                  this[`${prefixMethod}${eventName}`]({ channelName, args: args });
               }
            });
         });
      },

      /**
       *
       * @param name
       * @param channelEvents
       * @param prefixMethod
       * @returns {Promise<void>}
       */
      joinAgoraRtmChannel: async function(name, channelEvents = RTM_CONFIGS.CHANNEL_EVENTS, prefixMethod = RTM_CONFIGS.PREFIX_METHOD) {
         const channel = this.client.createChannel(name);
         this.$store.commit("UPDATE_CHANNEL", {
            name: name,
            channel: {
               channel,
               joined: false
            }
         });
         this.subscribeAgoraRtmChannelEvents(name, channelEvents, prefixMethod);
         return channel.join();
      },

      getChannelMemberCount(channels) {
         this.client.getChannelMemberCount(channels).then((data) => {
            this.updateStreamStatistic({
               view_count: data[this.currentChannel] || 1
            });
         });
      },

      /**
       *
       * @param name
       * @returns {Promise<*>}
       */
      leaveAgoraRtmChannel: async function(name) {
         if (!this.channels[name] || (this.channels[name] && !this.channels[name].joined)) {
            console.log("Fail Leave");
            return;
         } else {
            console.log("Start Leave");
            let _this = this;
            return this.channels[name].channel
               .leave()
               .then(() => {
                  if (_this.channels[name]) {
                     _this.$store.commit("UPDATE_STATUS_JOIN_OF_CHANNEL", {
                        name: name,
                        joined: false
                     });
                     _this.$store.commit("DELETE_CHANNEL", {
                        name: name,
                        channel: null
                     });
                  }
               })
               .catch((error) => {
                  console.error(error);
               });
         }
      },

      /**
       *
       * @param text
       * @param channelName
       * @returns {Promise<void|*>}
       */
      sendAgoraRtmChannelMessage: async function(text, channelName) {
         if (!this.channels[channelName] || !this.channels[channelName].joined) {
            return;
         }

         // Calculator Limit send:
         if (this.waitDuration < 0) {
            // reject message
            return;
         } else if (this.waitDuration === 0) {
            return this.channels[channelName].channel.sendMessage({ text });
         } else {
            let _this = this;
            return setTimeout(() => {
               _this.channels[channelName].channel.sendMessage({ text });
            }, this.waitDuration * 1000);
         }
      },

      /**
       *
       * @param text
       * @param peerId
       * @returns {Promise<PeerMessageSendResult>}
       */
      sendAgoraRtmPeerMessage: async function(text, peerId) {
         return this.client.sendMessageToPeer({ text }, peerId.toString());
      },

      /**
       *
       * @param memberId
       * @returns {Promise<PeersOnlineStatusResult>}
       */
      queryAgoraRtmPeersOnlineStatus: async function(memberId) {
         return this.client.queryPeersOnlineStatus([memberId]);
      },

      /**
       *
       * @param args
       */
      receivedAdminChannelMessage: function(args) {
         let messageChannel = JSON.parse(args.args[0].text);
         this.switchMessageType(messageChannel, true);
      },

      /**
       *
       * @param args
       */
      receivedChatChannelMessage: function(args) {
         this.myRtmWorker.postMessage({
            type: TYPE_WORKERS.RECEIVED_NEW_MESSAGE,
            data: args
         });
      },

      /**
       *
       * @param args
       */
      receivedChatMemberCountUpdated(args) {
         this.updateStreamStatistic({
            view_count: args.args[0] || 1
         });
      },

      /**
       *
       * @param message
       * @param channelName
       * @returns {Promise<void>}
       */
      sendNewChannelMessage: async function(message, channelName = null) {
         // let _this = this;
         this.sendAgoraRtmChannelMessage(JSON.stringify(message), channelName ? channelName : this.currentChannel).then(() => {
            if (message.MessageType === RTM_MESSAGE_TYPE.MESSAGE) {
               // Handle chat local
               this.myRtmWorker.postMessage({
                  type: TYPE_WORKERS.SENT_NEW_MESSAGE,
                  data: message
               });

               /*
                * Save chat local and prepare send to server:
                */
               this.addNewYourMessages(message);
            }
            else if (message.MessageType === RTM_MESSAGE_TYPE.ADMIN_DELETE_MESSAGE) {
               // Handle chat local
               this.myRtmWorker.postMessage({
                  type: TYPE_WORKERS.REMOVE_MESSAGE,
                  data: message
               });
            }
         });
      },

      /**
       *
       * @param message
       * @param isAdmin
       */
      switchMessageType: function(message, isAdmin = false) {
         switch (message.MessageType) {
            // case RTM_MESSAGE_TYPE.USER_LEFT:
            case RTM_MESSAGE_TYPE.USER_JOIN: {
               let newUser = {
                  UserId: parseInt(message.GuestId) | 1,
                  UserName: message.UserName
               };
               let checkUserHasJoined = this.listUserJoined.filter((user) => {
                  return user.UserId === newUser.UserId;
               });

               if (!checkUserHasJoined.length) {
                  this.updateListUserJoined(newUser);
               }
               break;
            }

            case RTM_MESSAGE_TYPE.MESSAGE: {
               if (isAdmin && message.GuestId === ADMIN_ACC.GuestId && message.DisplayName === ADMIN_ACC.DISPLAY_NAME) {
                  let formatHasUrlMessage = checkMessageHasUrls(message.Message);

                  message = Object.assign(message, {
                     Message: formatHasUrlMessage.message,
                     HasUrl: formatHasUrlMessage.hasUrl
                  });

                  console.log(message);

                  // Handle chat local
                  this.myRtmWorker.postMessage({
                     type: TYPE_WORKERS.SENT_NEW_MESSAGE,
                     data: message
                  });
               }
               break;
            }

            case RTM_MESSAGE_TYPE.LIKE: {
               if (!message.IsLiked && message.userName !== "init_bot_list") {
                  this.updateStreamStatistic({
                     like_count: this.streamStatistic.like_count++
                  });
               }
               let transition = {
                  bgClassAnimation: "bg-animation-" + Math.floor(Math.random() * 3 + 1),
                  animationClass: "animation-style-" + Math.floor(Math.random() * 3 + 1)
               };

               this.addNewLikedAnimation(transition);
               break;
            }

            case RTM_MESSAGE_TYPE.STATISTIC: {
               this.updateStreamStatistic(message);
               break;
            }

            case RTM_MESSAGE_TYPE.TURN_OFF_COMMENT: {
               this.updateStreamStatistic({ enable_chat: false });
               break;
            }

            case RTM_MESSAGE_TYPE.TURN_ON_COMMENT: {
               this.updateStreamStatistic({ enable_chat: true });
               break;
            }

            case RTM_MESSAGE_TYPE.HOST_STREAM_ENDED: {
               this.$root.$emit("stream-ended");
               break;
            }

            case RTM_MESSAGE_TYPE.ADMIN_DELETE_MESSAGE: {
               // Handle chat local
               this.myRtmWorker.postMessage({
                  type: TYPE_WORKERS.REMOVE_MESSAGE,
                  data: message
               });
               break;
            }
         }
      }
   },
   async beforeDestroy() {
      let _this = this;
      $.each(this.channels, function(nameChannel) {
         _this.leaveChannelRtm(nameChannel);
      });
      if (this.myRtmWorker) {
         try {
            await this.myRtmWorker.terminate();
         } catch (e) {
            console.log(e);
         }
      }
   }
};
